export default "__VITE_ASSET__Cq0ePJvq__"